import React, { useState } from "react";
import { toast } from "react-toastify";
import { FaRegEnvelope } from "react-icons/fa";
import { FiKey } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Header from "./Header/Header";
import { login } from "../slices/authSlice";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email,
      password,
    };

    try {
      const response = await fetch("https://api.greymatterz.com/api/v1/login", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      });
      const loginResponse = await response.json();

      if (loginResponse?.status === true) {
        toast.success(loginResponse?.message);

        // Dispatch login action
        dispatch(
          login({
            userId: loginResponse?.data?._id,
            token: loginResponse?.token,
          })
        );

        // Reset state
        setEmail("");
        setPassword("");
        navigate("/blogs");
      } else {
        toast.error(loginResponse?.message);
      }
    } catch (error) {
      console.error("Error during login:", error);
      toast.error("An error occurred while logging in.");
    }
  };

  const handleSignup = () => {
    navigate("/signup");
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <div className="login-container">
        <div className="login-form">
          <h3
            className="text-center my-4 position-relative title"
            style={{ fontSize: "30px" }}
          >
            Log In
          </h3>
          <div className="px-md-3 px-lg-4 px-xl-5 mt-4">
            <form onSubmit={onSubmit}>
              <div className="form-group mb-3 inputWithIcon">
                <span className="icon">
                  <FaRegEnvelope />
                </span>
                <input
                  placeholder="Your email"
                  type="email"
                  className="form-control"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="form-group mb-4 inputWithIcon">
                <span className="icon">
                  <FiKey />
                </span>
                <input
                  placeholder="Password"
                  type="password"
                  className="form-control"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button
                type="submit"
                className="btn btnLogin btn-primary text-center mt-4"
              >
                Login
              </button>
              {/*  <p className="alreadyAccount text-center my-3">
                Don't have an account? <Link to="/signup">Sign Up Now.</Link>
              </p>*/}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
